// extracted by mini-css-extract-plugin
export default {"size-checked":"Size_size-checked__WTlrn","label-size":"Size_label-size__aHXrv","size-wrapper":"Size_size-wrapper__yThYe","checked":"Size_checked__L2uK5"};